import Card from 'components/card';
import Spinner from 'components/spinner';
import React from 'react';
import { useParams } from 'react-router-dom';
import { listAmountCollectedRecon, splitAmountCollected } from 'stores/ApiHelper';
import ResponseTable from './components/ResponseTable';
import CreateSplit from './components/CreateSplit';
import { Split } from 'stores/types';

const EasySplitOpsDetails = () => {
    let { amount_collected_id } = useParams();
    const [loading, setLoading] = React.useState<boolean>(true);
    const [data, setData] = React.useState<any>(null);
    const [error, setError] = React.useState<any>(null);

    const [splitError, setSplitError] = React.useState<any>(null);

    const getAmountCollectedDetails = React.useCallback(async (amountCollectedId) => {
        try {
            setLoading(true);
            const response = await listAmountCollectedRecon(amountCollectedId);
            if (response.data?.status === "success" && response.data.data) {
                if (response.data.data.cashfreeAmountCollected) {
                    response.data.data.cashfreeAmountCollected = {
                        ...response.data.data.cashfreeAmountCollected,
                        settlementIds: response.data.data.cashfreeAmountCollected.settlementIds && Array.isArray(response.data.data.cashfreeAmountCollected.settlementIds) ? response.data.data.cashfreeAmountCollected.settlementIds.join(",") : response.data.data.cashfreeAmountCollected.settlementIds
                    }
                }

                if (response.data.data.cashfreeSplitItemDetails && Array.isArray(response.data.data.cashfreeSplitItemDetails)) {
                    response.data.data.cashfreeSplitItemDetails = response.data.data.cashfreeSplitItemDetails.map(sid => {
                        if (sid.payoutUser) {
                            sid.payoutUser = sid.payoutUser.name;
                        }
                        if (sid.cashfreeVendor) {
                            sid.cashfreeVendor = sid.cashfreeVendor.cashfreeVendorId;
                        }
                        if (sid.cashfreeSettlement) {
                            sid.cashfreeSettlement = sid.cashfreeSettlement.settlementId;
                        }
                        sid.Status = sid.status;
                        delete sid.status;
                        return sid;
                    });
                }

                if (response.data.data.cashfreeSettlements && Array.isArray(response.data.data.cashfreeSettlements)) {
                    response.data.data.cashfreeSettlements = response.data.data.cashfreeSettlements.map(s => {
                        if (s.amountCollectedIds && Array.isArray(s.amountCollectedIds)) {
                            s.amountCollectedIds = s.amountCollectedIds.join(",");
                        }
                        return s;
                    });
                }
                setData(response.data.data);
            }
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        getAmountCollectedDetails(amount_collected_id);
    }, [amount_collected_id, getAmountCollectedDetails]);

    const onSplit = async (splits: Split[]) => {
        try {
            setSplitError(null);
            await splitAmountCollected(amount_collected_id, splits);
            getAmountCollectedDetails(amount_collected_id);
        } catch (err) {
            setSplitError(err);
        }
    }

    if (loading) {
        return <Spinner />
    }

    if (error) {
        return (
            <div>
                <ResponseTable data={[]} responseError={error} />
            </div>
        )
    }

    if (data) {
        return (
            <div>
                <Card extra={'w-full h-full sm:overflow-auto mt-5 px-6 py-4'}>
                    <h2 className="text-xl font-bold text-navy-700 dark:text-white mb-2">Amount Collected</h2>
                    <ResponseTable data={{ data: [data.cashfreeAmountCollected] }} responseError={null} dateColumns={{ createdOn: true, updatedOn: true, paymentTime: true }} amountColumns={{ amount: true, "serviceCharge-serviceTax": true, "serviceCharge-serviceCharge": true, "serviceCharge-splitServiceTax": true, "serviceCharge-splitServiceCharge": true }} showTableName={false} showResponseTable={false} />
                </Card>

                <Card extra={'w-full h-full sm:overflow-auto mt-5 px-6 py-4'}>
                    <h2 className="text-xl font-bold text-navy-700 dark:text-white mb-2">Split</h2>
                    {
                        (data.cashfreeSplitItemDetails && data.cashfreeSplitItemDetails.length) || splitError ? (
                            <ResponseTable data={{ data: data.cashfreeSplitItemDetails }} responseError={splitError} dateColumns={{ createdOn: true, updatedOn: true }} amountColumns={{ amount: true }} showTableName={false} showResponseTable={false} />
                        ) : <CreateSplit onSplit={onSplit} />
                    }
                </Card>
                <Card extra={'w-full h-full sm:overflow-auto mt-5 px-6 py-4'}>
                    <h2 className="text-xl font-bold text-navy-700 dark:text-white mb-2">Settlement Details</h2>
                    <ResponseTable data={{ data: data.cashfreeSettlements }} responseError={data.cashfreeSettlements && data.cashfreeSettlements.length ? null : "No settlements found"} dateColumns={{ createdOn: true, updatedOn: true, paymentTime: true }} amountColumns={{ amount: true, amountSettled: true }} showTableName={false} />
                </Card>
            </div>
        )
    }

    return null;
}

export default EasySplitOpsDetails;